// extracted by mini-css-extract-plugin
export var closeButton = "_ay-0";